var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80.424,
    height: 95.987,
    viewBox: "0 0 80.424 95.987",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trophy_2_",
    "data-name": "trophy (2)",
    transform: "translate(-10.16 -4.095)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_192157",
    "data-name": "Path 192157",
    d: "M65.588,75.261v3.952a1.013,1.013,0,0,1-1.018,1.009H27.44a1.013,1.013,0,0,1-1.018-1.009V75.261a1.013,1.013,0,0,1,1.018-1.009h37.13A1.013,1.013,0,0,1,65.588,75.261Z",
    transform: "translate(4.604 19.859)",
    fill: "#a8644c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192158",
    "data-name": "Path 192158",
    d: "M63.016,68.639v9.083H28.049V68.639c2.6-2.6,4.045-4.054,6.649-6.649H56.367Z",
    transform: "translate(5.064 16.388)",
    fill: "#a8644c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9068",
    "data-name": "Rectangle 9068",
    width: 34.974,
    height: 2.27,
    transform: "translate(33.109 91.841)",
    fill: "#9b543e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192159",
    "data-name": "Path 192159",
    d: "M53.22,60.935V62.8H34.093V60.935a1.8,1.8,0,0,1,1.8-1.8H51.409A1.807,1.807,0,0,1,53.22,60.935Z",
    transform: "translate(6.775 15.58)",
    fill: "#ffb612"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192160",
    "data-name": "Path 192160",
    d: "M70.255,9.381A80.073,80.073,0,0,1,46.72,66.173c-1.833-1.834-3.567-3.734-5.178-5.7a80.055,80.055,0,0,1-18.3-53.147H70.2C70.221,8.015,70.255,8.693,70.255,9.381Z",
    transform: "translate(3.696 0.915)",
    fill: "#ffc536"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192161",
    "data-name": "Path 192161",
    d: "M45.207,62.036h2.3c-.562-.862-1.114-1.728-1.638-2.608A80,80,0,0,1,35.2,7.326H25.555a80.056,80.056,0,0,0,18.3,53.147C44.29,61,44.755,61.516,45.207,62.036Z",
    transform: "translate(4.351 0.915)",
    fill: "#ffd964",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192162",
    "data-name": "Path 192162",
    d: "M66.211,9.381A80.073,80.073,0,0,1,42.677,66.173c-1.833-1.834-3.567-3.734-5.178-5.7a18.291,18.291,0,0,0,8.4-5.645c3.167-3.656,5.134-8.156,6.922-12.645A256.61,256.61,0,0,0,63.256,10.026a22.233,22.233,0,0,1,.811-2.7h2.089C66.178,8.015,66.211,8.693,66.211,9.381Z",
    transform: "translate(7.739 0.915)",
    fill: "#ffb612"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192163",
    "data-name": "Path 192163",
    d: "M51.146,61.852H35.412l.633-1.067c.178-.322.356-.633.522-.945a26.579,26.579,0,0,0,3.111-10.323H46.89c.022.2.044.411.067.611A26.517,26.517,0,0,0,50,59.841C50.368,60.508,50.757,61.185,51.146,61.852Z",
    transform: "translate(7.148 12.858)",
    fill: "#ffd964"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192164",
    "data-name": "Path 192164",
    d: "M51.146,61.717H35.412l.633-1.067a9.914,9.914,0,0,0,6.567-3.3,19.091,19.091,0,0,0,2.311-3.6c.678-1.255,1.356-2.5,2.033-3.756A26.517,26.517,0,0,0,50,59.706C50.368,60.373,50.757,61.051,51.146,61.717Z",
    transform: "translate(7.148 12.993)",
    fill: "#ffc536"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192165",
    "data-name": "Path 192165",
    d: "M46.323,51.656H39.029a1.473,1.473,0,0,1-1.473-1.473V49.9a1.473,1.473,0,0,1,1.473-1.473h7.294A1.473,1.473,0,0,1,47.8,49.9v.282A1.473,1.473,0,0,1,46.323,51.656Z",
    transform: "translate(7.755 12.549)",
    fill: "#ffc536"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9069",
    "data-name": "Rectangle 9069",
    width: 20.623,
    height: 9.066,
    transform: "translate(40.283 81.71)",
    fill: "#f4ccba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192166",
    "data-name": "Path 192166",
    d: "M54.26,64.587v9.067H33.637v-.2C37.37,74,41.2,72.665,44.593,70.9A42.682,42.682,0,0,0,53.6,64.587h.656Z",
    transform: "translate(6.646 17.123)",
    fill: "#f7bda6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192167",
    "data-name": "Path 192167",
    d: "M35.317,65.61a.55.55,0,1,1-.544-.556A.546.546,0,0,1,35.317,65.61Zm0,6.883a.55.55,0,1,1-.544-.556A.546.546,0,0,1,35.317,72.493Zm18.2-6.883a.55.55,0,1,1-.544-.556A.546.546,0,0,1,53.518,65.61Zm0,6.883a.55.55,0,1,1-.544-.556A.546.546,0,0,1,53.518,72.493Z",
    transform: "translate(6.81 17.256)",
    fill: "#a8644c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192168",
    "data-name": "Path 192168",
    d: "M25.61,23.179a18.979,18.979,0,0,0,1.506-5.252A7.949,7.949,0,0,0,25.923,12.4c-2.421-3.326-7.514-3.88-10.869-1.508-3.415,2.267-5.014,6.478-4.888,10.356a23.009,23.009,0,0,0,3.464,10.806,28.73,28.73,0,0,0,7.589,8.306c3.074,2.266,6.571,3.6,9.689,5.175a21.084,21.084,0,0,1,4.32,2.838,10.856,10.856,0,0,1,3.017,4.021,7.076,7.076,0,0,1,.265,4.964,5.925,5.925,0,0,1-3.351,3.835,5.918,5.918,0,0,0,4-3.594,8.07,8.07,0,0,0,.289-5.636c-1.21-3.751-4.384-6.379-7.558-8.206-3.2-1.887-6.516-3.209-9.194-5.371a26.827,26.827,0,0,1-6.833-7.669,20.983,20.983,0,0,1-3.239-9.555,10.9,10.9,0,0,1,.75-4.795,9.044,9.044,0,0,1,2.847-3.82A6.58,6.58,0,0,1,20.671,11.2a5.937,5.937,0,0,1,4.248,1.975,6.969,6.969,0,0,1,1.512,4.711A23.523,23.523,0,0,1,25.61,23.179Z",
    transform: "translate(0 1.513)",
    fill: "#ffc536"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192169",
    "data-name": "Path 192169",
    d: "M38.875,57.212a5.934,5.934,0,0,1-4,3.6,5.952,5.952,0,0,0,3.356-3.845,7.112,7.112,0,0,0,.1-3.855,7.244,7.244,0,0,0-.322-1.533C36.8,47.823,33.63,45.2,30.452,43.367c-3.2-1.878-6.511-3.2-9.189-5.367a26.672,26.672,0,0,1-6.834-7.667,21.048,21.048,0,0,1-3.245-9.556,10.992,10.992,0,0,1,.756-4.8,9.087,9.087,0,0,1,2.845-3.811,6.584,6.584,0,0,1,4.456-1.355c.056,0,.1.011.156.011a6.534,6.534,0,0,0-3.467,1.344,9.18,9.18,0,0,0-2.845,3.811,10.985,10.985,0,0,0-.745,4.8,20.9,20.9,0,0,0,3.234,9.556A26.837,26.837,0,0,0,22.408,38c2.678,2.167,6,3.489,9.2,5.367,3.167,1.833,6.345,4.456,7.556,8.212A8.111,8.111,0,0,1,38.875,57.212Z",
    transform: "translate(0.285 1.898)",
    fill: "#ffb612"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192170",
    "data-name": "Path 192170",
    d: "M63.934,23.179a18.979,18.979,0,0,1-1.506-5.252A7.949,7.949,0,0,1,63.621,12.4c2.421-3.326,7.514-3.88,10.869-1.508C77.9,13.159,79.5,17.37,79.377,21.247a23.009,23.009,0,0,1-3.464,10.806,28.73,28.73,0,0,1-7.589,8.306c-3.074,2.266-6.571,3.6-9.689,5.175a21.085,21.085,0,0,0-4.32,2.838A10.856,10.856,0,0,0,51.3,52.394a7.076,7.076,0,0,0-.265,4.964,5.926,5.926,0,0,0,3.351,3.835,5.918,5.918,0,0,1-4-3.594,8.07,8.07,0,0,1-.289-5.636c1.21-3.751,4.384-6.379,7.558-8.206,3.2-1.887,6.516-3.209,9.194-5.371a26.826,26.826,0,0,0,6.833-7.669,20.983,20.983,0,0,0,3.239-9.555,10.9,10.9,0,0,0-.75-4.795,9.044,9.044,0,0,0-2.847-3.82A6.58,6.58,0,0,0,68.872,11.2a5.937,5.937,0,0,0-4.248,1.975,6.969,6.969,0,0,0-1.512,4.711A23.525,23.525,0,0,0,63.934,23.179Z",
    transform: "translate(11.199 1.513)",
    fill: "#ffc536"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192171",
    "data-name": "Path 192171",
    d: "M50.384,57.212a5.934,5.934,0,0,0,4,3.6,5.952,5.952,0,0,1-3.356-3.845,7.112,7.112,0,0,1-.1-3.855,7.244,7.244,0,0,1,.322-1.533c1.211-3.756,4.378-6.378,7.556-8.212,3.2-1.878,6.511-3.2,9.189-5.367a26.672,26.672,0,0,0,6.834-7.667,21.049,21.049,0,0,0,3.245-9.556,10.992,10.992,0,0,0-.756-4.8,9.087,9.087,0,0,0-2.845-3.811,6.584,6.584,0,0,0-4.456-1.355c-.056,0-.1.011-.156.011a6.534,6.534,0,0,1,3.467,1.344,9.18,9.18,0,0,1,2.845,3.811,10.985,10.985,0,0,1,.745,4.8,20.9,20.9,0,0,1-3.233,9.556A26.837,26.837,0,0,1,66.851,38c-2.678,2.167-6,3.489-9.2,5.367-3.167,1.833-6.345,4.456-7.556,8.212A8.111,8.111,0,0,0,50.384,57.212Z",
    transform: "translate(11.199 1.898)",
    fill: "#ffb612"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192172",
    "data-name": "Path 192172",
    d: "M70.838,8.73H23.607a2.115,2.115,0,0,1-2.115-2.115v-.4a2.115,2.115,0,0,1,2.115-2.115H70.838A2.115,2.115,0,0,1,72.954,6.21v.4A2.115,2.115,0,0,1,70.838,8.73Z",
    transform: "translate(3.208)",
    fill: "#ffc536"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192173",
    "data-name": "Path 192173",
    d: "M21.521,6.189A2.312,2.312,0,0,0,23.8,8.137H70.628a2.312,2.312,0,0,0,2.28-1.948Z",
    transform: "translate(3.216 0.593)",
    fill: "#ffb612"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.b4223c0a3bf111e5af89379a872f5568.svg";
export { ForwardRef as ReactComponent };